import { makeStyles } from '@material-ui/styles'
import { Theme } from '@material-ui/core'
import { blue } from '../../../../lib/Colors'

export default makeStyles(
	(theme: Theme) => ({
		uploadDropzone: {
			backgroundColor: 'rgba(42, 167, 220, 0.1);',
			border: '1px dashed #2AA7DC',
			borderRadius: '6px',
			color: blue,
			display: 'flex',
			alignItems: 'center',
			padding: '24px',
			marginTop: '24px',
			flexDirection: 'column',
			height: '150px',
		},
		uploadInput: {
			marginBottom: '16px',
		},
		manualUploadText: {
			fontWeight: 'normal',
			marginTop: '8px',
			marginBottom: '8px',
		},
	}),
	{ index: 1 },
)
